<!--  -->
<template>
  <div>
    <el-form
      label-position="right"
      label-width="150px"
      :model="formLabelAlign"
    >
      <el-form-item label="选择群主">
        <el-tag
          v-if="employee_no!=''&& name!=''"
          style="margin-right:10px"
        >{{ name }}</el-tag>
        <!-- :disabled="type === 2" -->
        <el-button
          type="primary"
          size="mini"
          @click="choose"
        >选择人员</el-button>
      </el-form-item>
      <el-form-item label="新群主成为群主时间">
        <el-input
          v-model="formLabelAlign.group_owner_time"
          v-integer-only
          class="el-input__inner_group"
          placeholder="请输入1-30天"
        />天
      </el-form-item>
      <el-form-item label="原群主退群时间">
        <el-input
          v-model="formLabelAlign.leave_time"
          v-integer-only
          class="el-input__inner_group"
          placeholder="请输入1-30天"
        />天
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="sumbit"
        >确定</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="选择新群主"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <configGroup
        ref="configGroup"
        @spWork="spWork"
      />
    </el-dialog>
    <el-dialog
      title="选择新群主"
      :visible.sync="dialogVisibletwo"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <configGrouptwo
        ref="configGrouptwo"
        @callspWork="callspWork"
      />
    </el-dialog>
  </div>
</template>

<script>
import configGroup from './configGroup.vue'
import configGrouptwo from './configGrouptwo.vue'
import { setGroupOwner, configDetail } from '@/api/officialaccount.js'
export default {
  components: { configGroup, configGrouptwo },
  // input限制整数
  directives: {
    integerOnly: {
      bind: function(el) {
        el.addEventListener('input', function(e) {
          let value = e.target.value
          value = value.replace(/\D/g, '')
          let intValue = value ? parseInt(value) : ''
          if (intValue < 1) {
            intValue = ''
          } else if (intValue > 30) {
            intValue = 30
          }
          e.target.value = intValue
        })
      }
    }
  },
  data() {
    return {
      formLabelAlign: {
        // newhost: '',
        // olhost: ''
        id: null,
        wx_id: null,
        leave_time: null,
        group_owner_time: null
      },
      user_id: '',
      dialogVisible: false,
      dialogVisibler: false,
      allcorp_iduser: [],
      employee_no: '',
      name: '',
      textarea: '',
      id: null,
      type: null,
      group_chat_name_rule: null,
      blurIndex: null,
      addtifit: '{number}',
      options: [
        {
          value: '数字',
          key: '{number}'
        }
      ],
      max_number: 40,
      corp_id: null,
      rowlist: {},
      rule_type: null,
      dialogVisibletwo: false
    }
  },
  created() {},
  mounted() {},
  deactivated() {
    console.log('guanl')
  },
  methods: {
    close() {
      this.name = ''
      this.formLabelAlign = {
        id: null,
        wx_id: null,
        leave_time: null,
        group_owner_time: null
      }
      this.user_id = ''
      this.rule_type = null
    },
    choose() {
      if (this.rule_type === 3) {
        this.dialogVisibletwo = true
        this.$nextTick(() => {
          this.$refs.configGrouptwo.open()
        })
      } else {
        this.dialogVisible = true
        this.$nextTick(() => {
          this.$refs.configGroup.open(2, this.rowlist, this.name)
        })
      }
    },
    spWork(item) {
      this.employee_no = item.employee_no
      this.name = item.name
      this.formLabelAlign.wx_id = item.wx_id
      this.dialogVisible = false
      this.corp_id = item.corp_id
      console.log(item)
    },
    callspWork(item) {
      this.employee_no = item.employee_no
      this.name = item.name
      this.user_id = item.user_id
      this.dialogVisibletwo = false
      this.corp_id = item.corp_id
      console.log(item)
    },
    send(type, item) {
      console.log('type, item:', type, item)
      this.rowlist = item
      console.log(item.rule_type)
      this.employee_no = item.employee_no
      this.rule_type = item.rule_type
      this.listr()
    },
    async listr() {
      this.loading = true
      const data = await configDetail({
        id: this.rowlist.id
      })
      console.log('data:', data)
      if (data.data === null) {
        return
      }
      if (this.rule_type === 3) {
        this.user_id = data.data.user_id
      }
      this.formLabelAlign.wx_id = data.data.wx_id
      this.formLabelAlign.leave_time = data.data.leave_time
      this.formLabelAlign.group_owner_time = data.data.group_owner_time
      this.id = data.data.group_chat_set_id
      this.name = data.data.name
      this.corp_id = this.rowlist.corp_id
    },
    async sumbit() {
      if (this.rule_type === 3) {
        if (this.user_id === '') {
          this.$message.error('请选择群主')
          return
        }
      } else {
        if (this.formLabelAlign.wx_id === null) {
          this.$message.error('请选择群主')
          return
        }
      }
      if (this.formLabelAlign.leave_time === null) {
        this.$message.error('请选择原群主退群时间')
        return
      }
      if (this.formLabelAlign.group_owner_time === null) {
        this.$message.error('请选择新群主成为群主的时间')
        return
      }
      this.formLabelAlign.id = this.rowlist.id
      console.log('this.formLabelAlign:', this.formLabelAlign)
      if (this.rule_type === 3) {
        const data = await setGroupOwner({
          group_owner_time: this.formLabelAlign.group_owner_time,
          id: this.formLabelAlign.id,
          leave_time: this.formLabelAlign.leave_time,
          user_id: this.user_id
        })
        console.log('data', data)
        this.$message({
          message: '群主更换成功',
          type: 'success'
        })
        this.close()
        this.$emit('updata')
      } else {
        const data = await setGroupOwner(this.formLabelAlign)
        console.log('data', data)
        this.$message({
          message: '群主更换成功',
          type: 'success'
        })
        this.close()
        this.$emit('updata')
      }
    },
    // 获取光标所在位置的index
    handleInputBlur(e) {
      this.blurIndex = e.srcElement.selectionStart
    },
    addidentifit() {
      this.textarea = this.textarea.slice(0, this.blurIndex) + this.addtifit + this.textarea.slice(this.blurIndex)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.el-input__inner_group {
  width: 134px;
}
@media (max-width: 768px){
  .el-input__inner_group {
    width: 30vw !important;
    margin:0px 1vw;
  }
}
</style>

